import { useState } from 'react';
import SectionHeading from '@/components/base/SectionHeading';

export const FAQ_ITEMS = [
  {
    q: '5看料网是一个什么样的网站？',
    a: '5看料网是一个专注娱乐与网络热点的速览型内容站点。我们把每条内容重新整理成速览要点、精简摘要和完整正文三层结构，让你可以用最短的时间掌握核心信息。',
  },
  {
    q: '这里的速览和普通资讯网站有什么区别？',
    a: '普通资讯站以发布为终点，速览以读完为终点。每篇内容开头都会先给出三到四条要点，再补充背景与进展，你不需要逐字阅读全文也能获得完整的信息框架。',
  },
  {
    q: '精简摘要模式该怎么用？',
    a: '打开任意一条速览，先读摘要区就能了解事件概况；若想深入，再继续往下阅读正文。这种分层结构特别适合通勤、排队这类碎片时间。',
  },
  {
    q: '内容多久更新一次？',
    a: '工作日每天上午和傍晚各更新一次，重大热点会在当天追加更新。首页的今日速览板块会优先呈现最新的条目。',
  },
  {
    q: '这些内容的来源可靠吗？',
    a: '所有内容都以公开信息为基础整理，并标注整理来源。我们只做信息归纳，不添加未经证实的判断，摘要也仅代表对公开信息的一次概览。',
  },
  {
    q: '阅读5看料网需要付费吗？',
    a: '目前全部速览内容都可以免费阅读。你可以通过订阅速览，在每次更新后收到一份精简汇总。',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section className="w-full border-t border-background-200 bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-16">
          <div className="lg:col-span-4">
            <SectionHeading
              kicker="FAQ"
              title="关于速览的常见问题"
              desc="如果你第一次接触速览式阅读，可以先看看这些问题。还有疑问可以通过联系我们页面反馈。"
            />
          </div>

          <div className="lg:col-span-8">
            <ul className="flex flex-col gap-3">
              {FAQ_ITEMS.map((item, index) => {
                const isOpen = openIndex === index;
                return (
                  <li
                    key={item.q}
                    className="overflow-hidden rounded-lg border border-background-200 bg-background-50"
                  >
                    <h3>
                      <button
                        type="button"
                        onClick={() => setOpenIndex(isOpen ? -1 : index)}
                        aria-expanded={isOpen}
                        className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left"
                      >
                        <span className="font-heading text-sm font-semibold text-foreground-950 md:text-base">
                          {item.q}
                        </span>
                        <span
                          className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-md transition-colors ${
                            isOpen ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-600'
                          }`}
                        >
                          <i
                            className={isOpen ? 'ri-subtract-line text-base' : 'ri-add-line text-base'}
                            aria-hidden="true"
                          ></i>
                        </span>
                      </button>
                    </h3>
                    {isOpen && (
                      <div className="border-t border-background-200 px-5 py-4">
                        <p className="font-body text-sm leading-relaxed text-foreground-600">{item.a}</p>
                      </div>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}